import React from 'react';
import {createBrowserRouter} from 'react-router-dom';

import Layout from '@components/Layout.tsx';
import SelfCheckinHome from '@/pages/home/page.tsx';

export function getDynamicRoutes() {
  const modules: Record<string, {default: React.ComponentType}> =
    import.meta.glob('/src/pages/**/page.tsx', {eager: true});
  const layoutModules: Record<string, {default: React.ComponentType}> =
    import.meta.glob('/src/pages/**/Layout.tsx', {eager: true});

  const routes = Object.keys(modules).reduce(
    (acc, path) => {
      if (!modules[path]?.default) {
        return acc;
      }

      const fileName = path.match(
        /pages\/(?!.*?\(.*?\)\/)(.*)\/page\.tsx/,
      )?.[1];

      if (!fileName) {
        return acc;
      }

      const normalizedPathName = fileName.replace(/\[(.*?)\]/g, ':$1');

      acc.push({
        path: `/${normalizedPathName}`,
        Element: modules[path].default,
        Layout: getLayoutModule(path, layoutModules),
      });

      return acc;
    },
    [] as {
      path: string;
      Element: React.ComponentType;
      Layout?: React.ComponentType;
    }[],
  );

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <SelfCheckinHome />,
        },
        ...routes.map(route => ({
          path: route.path,
          element: route.Layout
            ? React.createElement(
                route.Layout,
                {},
                React.createElement(route.Element),
              )
            : React.createElement(route.Element),
        })),
      ],
    },
  ]);

  return router;
}

const getLayoutModule = (path: string, layoutModules: Record<string, any>) => {
  const fileUrl = `${path.match(/(.*\/)page\.tsx/)?.[1]}Layout.tsx`;
  const parentDirUrl = `${path.match(/(.*\/)[^/]*\/page\.tsx/)?.[1]}Layout.tsx`;

  return (
    layoutModules[fileUrl]?.default || layoutModules[parentDirUrl]?.default
  );
};
